<script setup lang="ts">
import { useRoute } from 'vue-router';
import useMatestoreStore from '@/store/matestoreStore';
import useGlobalStore from '@/store/globalStore';
import MessageContainer from './MessageContainer.vue';
import HistoryTab from '@/components/tabs/HistoryTab.vue';
import { computed } from 'vue';
interface AppMainProps {
  fullsize?: boolean;
  disableTabs?: boolean;
  headerHeight?: number;
  sidebarWidth?: number;
  disableIm?: boolean;
  theme: 'v1' | 'v2';
}

const props = defineProps<AppMainProps>();
const matestoreStore = useMatestoreStore();
const globalStore = useGlobalStore();
const route = useRoute();

const containerHeight = computed(() => {
  return props.fullsize || !props.headerHeight
    ? '100vh'
    : `calc(100vh - ${props.headerHeight}px)`;
});

const containerWidth = computed(() => {
  return props.fullsize || !props.sidebarWidth
    ? '100vw'
    : `calc(100vw - ${props.sidebarWidth}px)`;
});
</script>
<template>
  <transition mode="out-in" name="fade-transform">
    <div
      :class="{
        'mate-micro-container': true,
        'mate-micro-container--fullsize': fullsize,
        'mate-micro-container--theme-v2': theme === 'v2',
      }"
      :style="{ width: containerWidth, height: containerHeight }"
    >
      <div
        v-show="!matestoreStore.showIm"
        :class="{
          'main-container': true,
          'main-container--with-tabs':
            matestoreStore?.currentApp?.multiple && !disableTabs,
        }"
      >
        <history-tab
          :theme="theme"
          v-if="matestoreStore?.currentApp?.multiple && !disableTabs"
        />

        <div class="mate-micro-inner">
          <keep-alive-vue3 :cache="false"></keep-alive-vue3>
        </div>
      </div>
      <message-container
        v-show="matestoreStore.showIm"
        v-if="
          globalStore.initialized &&
          !disableIm &&
          globalStore.hasAuthority('message')
        "
      />
    </div>
  </transition>
</template>
<style lang="scss" scoped>
.mate-micro-container {
  position: relative;
  box-sizing: border-box;
  &--fullsize {
    width: 100vw;
    height: 100vh;
    .mate-micro-inner {
      border-radius: 0;
    }
    .history-tab {
      border-radius: 0;
    }
  }
  &--sidebar-invisible {
    .mate-micro-inner {
      border-radius: 0;
    }
    .history-tab {
      border-radius: 0;
    }
  }
  &--theme-v2 {
    .history-tab {
      border-radius: 0;
    }
    .mate-micro-inner {
      border-radius: 0;
    }
  }
}
.main-container {
  height: 100%;
  position: relative;
  &--with-tabs {
    padding-top: 38px;
    .mate-micro-inner {
      border-radius: 0;
    }
  }
}
.mate-micro-inner {
  height: 100%;
  background: #ffffff;
  overflow-y: auto;
  border-radius: 12px 0 0 0;
}
</style>
